<div>
	<h1>{{ $t('vm.root.user.payment-method.title') }}</h1>
	<div v-if="isDemo">
		<section>
			<stripe-expiry-alert class="marg-v">
				<div class="notice-warning">
					<p class="text-left">
						<i18n path="vm.root.user.payment-method.demo.text" tag="p">
							<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
								<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
							</svg>
						</i18n>
					</p>
				</div>
			</stripe-expiry-alert>
		</section>
	</div>

	<div v-else>

		<section class="bordered-panel marg-v" v-if="canChangePaymentMethod">
			<header class="childs-space-between">
				<h2 class="text-md text-capitalize no-marg">{{ paymentTitle }}</h2>

				<span
					:class="['is-pushed-right', isExpired ? 'tag-danger' : 'tag-success']"
				>
				{{ $t(isExpired
						? 'vm.root.user.payment-method.expired'
						: 'vm.root.user.payment-method.default'
					) }}
			  </span>
			</header>

			<p v-if="isCard" class="marg-t">{{ cardExpirationText }}</p>

			<div class="text-right">
				<button
					type="button"
					class="btn--link-like"
					:title="$t('vm.root.user.payment-method.update-payment.title')"
					@click.prevent="changePaymentMethod"
				>
					{{ $t('vm.root.user.payment-method.update-payment.label') }}
				</button>
			</div>
		</section>
		<section v-else>
			<stripe-expiry-alert class="marg-v">
				<div class="notice-warning">
					<p class="text-left">
						<i18n path="vm.root.user.payment-method.no-license.text1" tag="p">
							<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
								<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
							</svg>
							<router-link
								:to="{ name: 'shop' }"
								:title="$t('vm.root.user.payment-method.no-license.title')">
								{{ $t('vm.root.user.payment-method.no-license.text2') }}
							</router-link>
						</i18n>
					</p>
				</div>
			</stripe-expiry-alert>
		</section>
	</div>

</div>
